import { isNil } from 'lodash';

import { DealershipDepartment } from 'services/resources';
import request from '../../request';

/**
 * Get Dealership settings
 */
export function dealershipSettings() {
  return request(`common/settings/`, {
    method: 'GET',
  });
}

/**
 * Accept Stripe TOS to enable payments
 */
export function acceptTerms(id) {
  return request(`common/settings/${id}/accept_payment_terms/`, {
    method: 'PATCH',
  });
}

export function paymentAccountLegalEntity(id) {
  return request(`common/settings/${id}/payment_account_legal_entity`, {
    method: 'GET',
  });
}

export function updateLegalEntity(id, legalEntity) {
  const outboundEntity = { ...legalEntity };

  delete outboundEntity.personalIdNumberProvided;
  delete outboundEntity.businessTaxIdProvided;
  delete outboundEntity.verification;
  delete outboundEntity.type;

  const { dob } = outboundEntity;

  if (!isNil(dob)) {
    const [year, month, day] = dob.split('-');
    outboundEntity.dob = {
      year,
      month,
      day,
    };
  }

  return request(`common/settings/${id}/payment_account_legal_entity/`, {
    method: 'PATCH',
    data: outboundEntity,
    noKeyTransform: ['address.line1'],
  });
}

export function updateLegalEntityDocument(id, file, options = { isBack: false }) {
  const data = new FormData();
  const endpoint = options.isBack
    ? `common/settings/${id}/payment_account_legal_entity_document_back/`
    : `common/settings/${id}/payment_account_legal_entity_document/`;

  data.append('document', file, file.name);

  return request(endpoint, {
    method: 'PATCH',
    data,
    noKeyTransform: true,
  });
}

export function authorizeMailChimpIntegration(id, code) {
  return request(`common/settings/${id}/mailchimp_authorize/`, {
    method: 'POST',
    data: {
      code,
    },
  });
}

export function pushCustomersToMailChimp(id) {
  return request(`common/settings/${id}/mailchimp_push_customers/`, {
    method: 'POST',
  });
}

export function getMailChimpCustomersListProgress(id) {
  return request(`common/settings/${id}/mailchimp_push_customers_progress`, {
    method: 'GET',
  });
}

export function getMailChimpAuthUrl() {
  return request(`common/settings/mailchimp_auth_url`, {
    method: 'GET',
  });
}

/**
 * Get Dealership departments
 */
export function dealershipDepartments() {
  return request<{ results: DealershipDepartment[] }>(`common/departments/`, {
    method: 'GET',
    params: {
      without_pagination: true, // TODO: Remove once this is default in the API
    },
  });
}

export function patchDealershipDepartment(id: number, department: Partial<DealershipDepartment>) {
  return request<DealershipDepartment>(`common/departments/${id}/`, {
    method: 'PATCH',
    data: department,
  });
}

export function createDealershipDepartment(department: DealershipDepartment) {
  return request<DealershipDepartment>(`common/departments/`, {
    method: 'POST',
    data: department,
  });
}

export function deleteDealershipDepartment(id: number) {
  return request(`common/departments/${id}/`, {
    method: 'DELETE',
  });
}
